import { Swiper } from 'swiper';

class ArchivePost {


  constructor() {
    this._init();
  }

  private _init() {
    const swiperEl = document.querySelector('.archive-post__swiper') as HTMLElement;
    if (swiperEl) {
      new Swiper(swiperEl, {
        direction: 'horizontal',
        slidesPerView: 'auto',
        spaceBetween: 8,
      });
    }
  }

}

export const archivePost = new ArchivePost();
